module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('upload-multi-file', {
    attrs: {
      "name": "adjuntar_boletas_manuales",
      "folder": "boletas-manuales"
    },
    on: {
      "save": _vm.guardarAdjuntos,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Adjunte los pdf de las boletas")]), _c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Recuerda que los archivos deben tener el DNI al inicio del nombre del archivo")])])], 1) : _vm._e()]), (_vm.mostrarConfirmacionEliminarTodo) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = false
      },
      "do": _vm.eliminarTodasLasBoletasManuales
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea eliminar todas las boletas cargadas?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Eliminando...")]) : _c('span', [_vm._v("Eliminar todo")])]), _c('strong', [_vm._v("Solo se eliminaran las boletas de la carga manual actual, no las generadas")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionGenerarBoletas) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionGenerarBoletas = false
      },
      "do": _vm.generarBoletasManuales
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea generar las boletas cargadas?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isProcessing) ? _c('span', [_vm._v("Generando...")]) : _c('span', [_vm._v("Generar")])]), _c('strong', [_vm._v("No cierre la pestaña del navegador mientras se están generando las boletas")]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProcessing),
      expression: "isProcessing"
    }],
    staticClass: "margin-top-10 margin-bottom-10"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s((_vm.cantidadAvance / _vm.cantidadTotal * 100).toFixed(2)) + "%")]), _c('span', {
    staticClass: "small ml-5"
  }, [_vm._v(_vm._s(_vm.cantidadAvance) + " / " + _vm._s(_vm.cantidadTotal))])])])], 1)], 1) : _vm._e(), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Carga manual de boletas")])]), _c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('ul', [_c('li', [_vm._v("Solo se pueden trabajar simultaneamente, boletas de un mismo periodo, mes y tipo")]), _c('li', [_vm._v("Los archivos pdf deben tener el DNI al inicio, seguido de un \"_\", para obtener el empleado automáticamente, sino se deberá hacer la asignación manualmente.")])])])]), _c('div', {
    staticClass: "display-flex ai-c filtros-completos"
  }, [_c('div', {
    staticClass: "display-flex flex-1 filtro-input"
  }, [_c('div', {
    staticClass: "flex-1 px-20"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Periodo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.periodo),
      expression: "periodo"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.periodo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.periodo = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "flex-1 px-20"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Mes")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mes),
      expression: "mes"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.mes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mes = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "flex-1 px-20"
  }, [_c('div', {
    staticClass: "control title-singular"
  }, [_c('p', [_vm._v("Tipo")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo),
      expression: "tipo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._l((_vm.tipos), function(o) {
    return _c('option', {
      domProps: {
        "value": o.codigo
      }
    }, [_vm._v(_vm._s(o.descripcion))])
  })], 2)])])])]), _c('div', {
    staticClass: "text-right media-pt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": _vm.openModalAdjuntar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload fs-12"
  })]), _c('span', [_vm._v("Adjuntar")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-fw fa-lg"
  })]), _c('span', [_vm._v("Refrescar")])])])]), _c('div', {
    staticClass: "mt-20"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    attrs: {
      "disabled": _vm.lista.length === 0 || _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionGenerarBoletas = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-bolt fa-fw fa-lg"
  })]), _c('span', [_vm._v("Generar boletas")])]), _c('button', {
    staticClass: "button is-small is-danger ml-5",
    on: {
      "click": function($event) {
        _vm.mostrarConfirmacionEliminarTodo = true
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times fa-fw fa-lg"
  })]), _c('span', [_vm._v("Eliminar todo")])])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVerifying),
      expression: "isVerifying"
    }],
    staticClass: "margin-top-10 margin-bottom-10"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v(_vm._s((_vm.cantidadAvance / _vm.cantidadTotal * 100).toFixed(2)) + "%")]), _c('span', {
    staticClass: "small ml-5"
  }, [_vm._v(_vm._s(_vm.cantidadAvance) + " / " + _vm._s(_vm.cantidadTotal))])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Empleado")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("DNI obtenido")]), _c('th', [_vm._v("Nombre de archivo")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Fecha de modificación")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.codigo
      }
    }, [_c('td', [(o.codigo) ? [_c('div', {
      staticClass: "show-break-1"
    }, [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "display-flex hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.codigo
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.desasignarEmpleadoABoletaManual(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleadoReemplazante),
        expression: "o.codigoEmpleadoReemplazante"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleadoReemplazante)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleadoReemplazante", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleadoReemplazante
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoABoletaManual(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)]], 2), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.dniObtenido))]), _c('td', [_c('div', [_vm._v(_vm._s(o.namefile))]), _c('div', {
      staticClass: "show-break-1 mt-10"
    }, [_c('strong', [_vm._v("Modificado: ")]), _c('span', [_vm._v(_vm._s(o.modificado))])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_vm._v(_vm._s(o.modificado))]), _c('td', {
      staticClass: "text-center"
    }, [(o.ruta) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])], _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger ml-5",
      class: {
        'is-loading': o.isRemoving
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])])], 2)])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'bg-red': !o.codigo
      }
    }, [(o.codigo) ? [_c('div', [_c('strong', [_vm._v("DNI: ")]), _c('span', [_vm._v(_vm._s(o.dniObtenido))])]), _c('div', {
      staticClass: "descripcion-tipo display-flex"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'Empleado: ' + o.id
      }
    }, [_vm._v(_vm._s(o.nombre))]), _c('div', {
      staticClass: "cursor-pointer ml-5",
      attrs: {
        "title": "Desasignar empleado"
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.desasignarEmpleadoABoletaManual(o)
        }
      }
    })])])] : [_c('div', {
      staticClass: "mb-10"
    }, [_c('div', {
      staticClass: "position-relative"
    }, [_c('div', {
      staticClass: "control display-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.codigoEmpleadoReemplazante),
        expression: "o.codigoEmpleadoReemplazante"
      }],
      staticClass: "input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (o.codigoEmpleadoReemplazante)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(o, "codigoEmpleadoReemplazante", $event.target.value)
        }
      }
    }), _c('span', {
      staticClass: "icon cursor-pointer margin-left-5",
      on: {
        "click": function($event) {
          o.mostrarBusquedaEmpleado = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-quick"
      }
    }, [(o.mostrarBusquedaEmpleado) ? _c('div', {
      staticClass: "pop-over"
    }, [_c('lookup-small-empleado', {
      attrs: {
        "codigo": o.codigoEmpleadoReemplazante
      },
      on: {
        "selected": function($event) {
          return _vm.asignarEmpleadoABoletaManual(o, $event)
        },
        "close": function($event) {
          o.mostrarBusquedaEmpleado = false
        }
      }
    })], 1) : _vm._e()])], 1)])], _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.namefile))])]), _c('div', {
      staticClass: "dias-pedidos mt-5"
    }, [_c('strong', [_vm._v("Fecha de modificación: ")]), _c('div', [_vm._v(_vm._s(o.modificado))])]), _c('div', {
      staticClass: "botones"
    }, [(o.ruta) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.ruta,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])], _c('button', {
      staticClass: "button is-small is-danger ml-5",
      class: {
        'is-loading': o.isRemoving
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(o.id, o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Eliminar")])])], 2)], 2)
  })], 2)] : _c('div', [_c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay documentos importantes ingresados")])])])], 2)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13246f5b","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Boletas_Carga_Manual.vue
// module id = 826
// module chunks = 0